import { type MouseEvent, memo, useState } from "react";
import { useContent } from "../../../../../../contexts/contentContext/contentContext";
import handleCopyValue from "../../../../../../utils/handleCopyValue";
import { IconWithTooltip } from "../../../../../Elements/Icon/Icon";
import Tooltip from "../../../../../Elements/Tooltip/Tooltip.js";
import { DOMAIN_NAME } from "../../../../../../utils/globalConsts.ts";

//@ts-ignore
import config from "config";

import styles from "./styles.module.scss";

interface JFormTitleI {
  deliveryNumber: string;
  formSubject: string;
  id: string;
  bucketName: string;
}

/**
 * Represents the title component for a form in the Inbox.
 *
 * @component
 * @param {JFormTitleI} props - The props for the JFormTitle component.
 * @returns {JSX.Element} The rendered JFormTitle component.
 */
const JFormTitle = memo((props: JFormTitleI) => {
  const { deliveryNumber, formSubject = "Test", id, bucketName } = props;
  const { getPath, getTextByKey } = useContent();
  const [copied, setCopied] = useState(false);
  const [hoverTitle, setHoverTitle] = useState(false);

  const handleCopy = (e: MouseEvent) => {
    e.stopPropagation();

    handleCopyValue(deliveryNumber, setCopied);
  };

  const baseUrl = bucketName
  ? bucketName.includes("jumbomail1")
    ? `https://${DOMAIN_NAME}`
    : bucketName.replace("files.", "")
  : config.baseurl;

  return (
    <div
      className={styles.jFormTitleWrapper}
      onMouseEnter={() => setHoverTitle(true)}
      onMouseLeave={() => setHoverTitle(false)}
    >
      <div className={styles.formData}>
        <a
          className={styles.deliveryNumber}
          //@ts-ignore
          href={`${baseUrl}${getPath()}gallery/${id}`}
          rel="noopener noreferrer"
          target="_blank"
        >
          #{deliveryNumber}
        </a>
        <div className={styles.copyTitleIcon}>
          <IconWithTooltip
            iconProps={{
              name: copied ? "newInbox/mark" : "copy",
              onClick: handleCopy,
              blue: true,
              medium: !copied,
              //@ts-ignore
              style: {
                opacity: +hoverTitle,
              },
            }}
            tooltipProps={{
              tooltipTextKey: "copy-delivery-number-tooltip",
            }}
          />
        </div>
        {/*@ts-ignore*/}
        <Tooltip
          tooltipTextKey={formSubject || getTextByKey("no-subject-text")}
        >
          <span className={styles.formSubject}>
            {formSubject || getTextByKey("no-subject-text")}
          </span>
        </Tooltip>
      </div>
    </div>
  );
});

export default JFormTitle;
